import { config } from '../../../../../config'

export const api = config.api;
export const api_next = config.api_next;
export const api_v3 = config.api_v3;
export const headers = {
  'Accept': '*/*',
  'Content-Type': 'application/json; charset=utf-8'
}